import {
  AssignmentAdd,
  AutoStoriesOutlined,
  QuizOutlined,
  VideoCameraFrontOutlined,
} from '@mui/icons-material';
import {
  alpha,
  Box,
  darken,
  lighten,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';

export default function LectureContentItem({
  active,
  completed,
  title,
  duration,
  type,
  onClick,
}) {
  const theme = useTheme();
  return (
    <Tooltip
      title={
        <Box>
          <Typography
            variant="body2"
            sx={{ fontWeight: 'bold', lineHeight: 1.5 }}
          >
            {title}
          </Typography>
          <Typography variant="caption">{duration}</Typography>
        </Box>
      }
    >
      <Box
        className={active ? 'active' : ''}
        onClick={!active ? onClick : undefined}
        sx={{
          borderRadius: 1,
          py: 1,
          px: 2,
          position: 'relative',
          '&:hover': {
            backgroundColor: darken(theme.palette.background.paper, 0.05),
          },
          '&:active': {
            backgroundColor: darken(theme.palette.background.paper, 0.1),
          },
          '&.active': {
            backgroundColor: alpha(theme.palette.primary.main, 0.05),
          },
          cursor: !active ? 'pointer' : 'default',
          userSelect: 'none',
        }}
      >
        {type === 'video' && (
          <VideoCameraFrontOutlined
            sx={{
              color: !completed
                ? lighten(theme.palette.text.secondary, 0.5)
                : theme.palette.success.main,
              fontSize: 20,
            }}
          />
        )}
        {type === 'text' && (
          <AutoStoriesOutlined
            sx={{
              color: !completed
                ? lighten(theme.palette.text.secondary, 0.5)
                : theme.palette.success.main,
              fontSize: 20,
            }}
          />
        )}
        {type === 'quiz' && (
          <QuizOutlined
            sx={{
              color: !completed
                ? lighten(theme.palette.text.secondary, 0.5)
                : theme.palette.success.main,
              fontSize: 20,
            }}
          />
        )}
        {type === 'assignment' && (
          <AssignmentAdd
            sx={{
              color: !completed
                ? lighten(theme.palette.text.secondary, 0.5)
                : theme.palette.success.main,
              fontSize: 20,
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
}
